import {
  IRecord_Job,
} from '../types/schema/job'

import {
  STATUS_COMPLETE,
  STATUS_ERROR,
} from '../constants'

export const isJobFinished = (job: IRecord_Job): boolean => {
  if(job.status == STATUS_COMPLETE) return true
  else if(job.status == STATUS_ERROR) return true
  else return false
}